"use client";

import { useEffect } from 'react';
import { useSession } from 'next-auth/react';
import { usePathname } from 'next/navigation';

export default function VisitorTracker() {
  const { data: session } = useSession();
  const pathname = usePathname();

  useEffect(() => {
    const trackVisitor = async () => {
      try {
        // 페이지 로드 시 방문자 추적
        const response = await fetch('/api/analytics/visitor', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            ip: 'client-side', // 서버에서 실제 IP 추출
            userAgent: navigator.userAgent,
            page: pathname,
            userId: session?.user?.id || null,
            isLoggedIn: !!session?.user,
            referrer: typeof document !== 'undefined' ? document.referrer || '직접 방문' : '직접 방문',
          }),
        });
        
        // 응답이 성공하지 않으면 에러 로깅만 (콘솔에만 표시, 무시)
        if (!response.ok) {
          console.debug('Analytics tracking failed (silent):', response.status);
        }
      } catch (error) {
        // 에러 발생 시 무시 (콘솔에도 표시하지 않음)
        // console.debug('Failed to track visitor (silent):', error);
      }
    };

    // 페이지 로드 후 1초 뒤에 추적 (페이지가 완전히 로드된 후)
    const timer = setTimeout(trackVisitor, 1000);

    return () => clearTimeout(timer);
  }, [pathname, session]);

  return null; // UI 렌더링 없음
}
